import React, { useState } from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ITripPlannerValues } from '../types/locationTypes';

const useStyles = makeStyles((theme) => ({
    textFieldInput: {
        width: "105%",
        height: "30px",
        textAlign: "center",
        borderColor: "#ECECEC",
        '& input': {
            textAlign: "center",
            fontSize: 14,
        },
    },
}));

interface PlannerShiftHoursRowNumberProps {
    parentClasses: ClassNameMap,
    title: any,
    values: any,
    planner: ITripPlannerValues,
    planners: ITripPlannerValues[],
    setUpdate: any,
    setPlanners: any,
    readonly:boolean,
    order: number
}
interface daysInterface {
    mon:any,
    tue:any,
    wed:any,
    thu:any,
    fri:any,
    sat:any,
    sun:any
}

const PlannerShiftHoursRowNumber: React.FC<PlannerShiftHoursRowNumberProps> = ({
    parentClasses,
    title,
    values,
    planner,
    planners,
    setUpdate,
    setPlanners,
    readonly,
    order
}) => {
    const classes = useStyles();

    const [days,setDays]=useState<daysInterface>();
    React.useEffect(() => {
        if (values){
           setDays(values);
        }
    }, [values]);

    const updatePlanner = (e: { target: { value: any|string; }; },title:string,field:string) => {
        let newPlanner = {...planner};
        let newPlanners = [...planners];
        let index = newPlanners.findIndex((x) => x.tripPlannerId === newPlanner.tripPlannerId);
        if( parseInt(e.target.value) <= 3600){
            switch(title){
                case "Break Duration (Mins)":
                    switch(field){
                        case "mon":
                            newPlanner.breakDurationMon=parseInt(e.target.value);
                            newPlanner.breakDurationMonString=e.target.value;
                            break;
                        case "tue":
                            newPlanner.breakDurationTue=parseInt(e.target.value);
                            newPlanner.breakDurationTueString=e.target.value;
                            break;
                        case "wed":
                            newPlanner.breakDurationWed=parseInt(e.target.value);
                            newPlanner.breakDurationWedString=e.target.value;
                            break;
                        case "thur":
                            newPlanner.breakDurationThu=parseInt(e.target.value);
                            newPlanner.breakDurationThuString=e.target.value;
                            break;
                        case "fri":
                            newPlanner.breakDurationFri=parseInt(e.target.value);
                            newPlanner.breakDurationFriString=e.target.value;
                            break;
                        case "sat":
                            newPlanner.breakDurationSat=parseInt(e.target.value);
                            newPlanner.breakDurationSatString=e.target.value;
                            break;
                        case "sun":
                            newPlanner.breakDurationSun=parseInt(e.target.value);
                            newPlanner.breakDurationSunString=e.target.value;
                            break;      
                    }
                    break;
                case "Max Break Delay (Hrs)":
                    switch(field){
                        case "mon":
                            newPlanner.maxBreakDelayMon=parseInt(e.target.value);
                            newPlanner.maxBreakDelayMonString=e.target.value;
                            break;
                        case "tue":
                            newPlanner.maxBreakDelayTue=parseInt(e.target.value);
                            newPlanner.maxBreakDelayTueString=e.target.value;
                            break;
                        case "wed":
                            newPlanner.maxBreakDelayWed=parseInt(e.target.value);
                            newPlanner.maxBreakDelayWedString=e.target.value;
                            break;
                        case "thur":
                            newPlanner.maxBreakDelayThu=parseInt(e.target.value);
                            newPlanner.maxBreakDelayThuString=e.target.value;
                            break;
                        case "fri":
                            newPlanner.maxBreakDelayFri=parseInt(e.target.value);
                            newPlanner.maxBreakDelayFriString=e.target.value;
                            break;
                        case "sat":
                            newPlanner.maxBreakDelaySat=parseInt(e.target.value);
                            newPlanner.maxBreakDelaySatString=e.target.value;
                            break;
                        case "sun":
                            newPlanner.maxBreakDelaySun=parseInt(e.target.value);
                            newPlanner.maxBreakDelaySunString=e.target.value;
                            break;
                    }
                    break;
                
            }
        }
        else{
            switch(title){
                case "Break Duration (Mins)":
                    switch(field){
                        case "mon":
                            newPlanner.breakDurationMon=null;
                            newPlanner.breakDurationMonString=e.target.value;
                            break;
                        case "tue":
                            newPlanner.breakDurationTue=null;
                            newPlanner.breakDurationTueString=e.target.value;
                            break;
                        case "wed":
                            newPlanner.breakDurationWed=null;
                            newPlanner.breakDurationWedString=e.target.value;
                            break;
                        case "thur":
                            newPlanner.breakDurationThu=null;
                            newPlanner.breakDurationThuString=e.target.value;
                            break;
                        case "fri":
                            newPlanner.breakDurationFri=null;
                            newPlanner.breakDurationFriString=e.target.value;
                            break;
                        case "sat":
                            newPlanner.breakDurationSat=null;
                            newPlanner.breakDurationSatString=e.target.value;
                            break;
                        case "sun":
                            newPlanner.breakDurationSun=null;
                            newPlanner.breakDurationSunString=e.target.value;
                            break; 
                    }
                break;
                case "Max Break Delay (Hrs)":
                    switch(field){
                        case "mon":
                            newPlanner.maxBreakDelayMon=null;
                            newPlanner.maxBreakDelayMonString=e.target.value;
                            break;
                        case "tue":
                            newPlanner.maxBreakDelayTue=null;
                            newPlanner.maxBreakDelayTueString=e.target.value;
                            break;
                        case "wed":
                            newPlanner.maxBreakDelayWed=null;
                            newPlanner.maxBreakDelayWedString=e.target.value;
                            break;
                        case "thur":
                            newPlanner.maxBreakDelayThu=null;
                            newPlanner.maxBreakDelayThuString=e.target.value;
                            break;
                        case "fri":
                            newPlanner.maxBreakDelayFri=null;
                            newPlanner.maxBreakDelayFriString=e.target.value;
                            break;
                        case "sat":
                            newPlanner.maxBreakDelaySat=null;
                            newPlanner.maxBreakDelaySatString=e.target.value;
                            break;
                        case "sun":
                            newPlanner.maxBreakDelaySun=null;
                            newPlanner.maxBreakDelaySunString=e.target.value;
                            break;
                    }
                break;
                
            }
        }
        newPlanners[index]=newPlanner;
        setPlanners(newPlanners);
    }
    const handleBlur = (e: { target: { value: any|string; }; },title:string,field:string) => {
            // Check if time is in the range of 9:00AM to 5:00PM
            if( parseInt(e.target.value) <= 3600){
                switch(title){
                    case "Break Duration (Mins)":
                        switch(field){
                            case "mon":
                                planner.breakDurationMon=parseInt(e.target.value);
                                break;
                            case "tue":
                                planner.breakDurationTue=parseInt(e.target.value);
                                break;
                            case "wed":
                                planner.breakDurationWed=parseInt(e.target.value);
                                break;
                            case "thur":
                                planner.breakDurationThu=parseInt(e.target.value);
                                break;
                            case "fri":
                                planner.breakDurationFri=parseInt(e.target.value);
                                break;
                            case "sat":
                                planner.breakDurationSat=parseInt(e.target.value);
                                break;
                            case "sun":
                                planner.breakDurationSun=parseInt(e.target.value);
                                break;      
                        }
                        break;
                    case "Max Break Delay (Hrs)":
                        switch(field){
                            case "mon":
                                planner.maxBreakDelayMon=parseInt(e.target.value);
                                break;
                            case "tue":
                                planner.maxBreakDelayTue=parseInt(e.target.value);
                                break;
                            case "wed":
                                planner.maxBreakDelayWed=parseInt(e.target.value);
                                break;
                            case "thur":
                                planner.maxBreakDelayThu=parseInt(e.target.value);
                                break;
                            case "fri":
                                planner.maxBreakDelayFri=parseInt(e.target.value);
                                break;
                            case "sat":
                                planner.maxBreakDelaySat=parseInt(e.target.value);
                                break;
                            case "sun":
                                planner.maxBreakDelaySun=parseInt(e.target.value);
                                break;
                        }
                        break;
                    
                }
            }
            else{
                switch(title){
                    case "Break Duration (Mins)":
                        switch(field){
                            case "mon":
                                planner.breakDurationMon=null;
                                break;
                            case "tue":
                                planner.breakDurationTue=null;
                                break;
                            case "wed":
                                planner.breakDurationWed=null;
                                break;
                            case "thur":
                                planner.breakDurationThu=null;
                                break;
                            case "fri":
                                planner.breakDurationFri=null;
                                break;
                            case "sat":
                                planner.breakDurationSat=null;
                                break;
                            case "sun":
                                planner.breakDurationSun=null;
                                break; 
                        }
                    break;
                    case "Max Break Delay (Hrs)":
                        switch(field){
                            case "mon":
                                planner.maxBreakDelayMon=null;
                                break;
                            case "tue":
                                planner.maxBreakDelayTue=null;
                                break;
                            case "wed":
                                planner.maxBreakDelayWed=null;
                                break;
                            case "thur":
                                planner.maxBreakDelayThu=null;
                                break;
                            case "fri":
                                planner.maxBreakDelayFri=null;
                                break;
                            case "sat":
                                planner.maxBreakDelaySat=null;
                                break;
                            case "sun":
                                planner.maxBreakDelaySun=null;
                                break;
                        }
                    break;
                    
                }
            }
    };
    
    return (
        <>
        <div className={title=="Max Break Delay (Hrs)" ? parentClasses.inputRowWithoutBorder : parentClasses.inputRow}>
        <Grid container className={'shiftHourGrid body'}>
            <Grid item md={3}>
                <div className={"subTitle"}>
                    {title}
                </div>
            </Grid>
            <Grid item md={9}  style={{flexBasis:'74.2%' }}>
                <Grid container className={"weekDayGrid"}>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-mon"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.mon ? days?.mon: "" }
                            onChange={(event) => updatePlanner(event,title,"mon")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-tue"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+5}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.tue ? days?.tue: "" }
                            onChange={(event) => updatePlanner(event,title,"tue")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-wed"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+10}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.wed ? days?.wed: "" }
                            onChange={(event) => updatePlanner(event,title,"wed")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-thu"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+15}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.thu ? days?.thu: "" }
                            onChange={(event) => updatePlanner(event,title,"thur")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-fri"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+20}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.fri ? days?.fri: "" }
                            onChange={(event) => updatePlanner(event,title,"fri")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-sat"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+25}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.sat ? days?.sat: "" }
                            onChange={(event) => updatePlanner(event,title,"sat")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id={planner.tripPlannerId+"-"+order+"-sun"}
                            InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+30}
                                        }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant='outlined'
                            type="text"                   
                            value={days?.sun ? days?.sun: "" }
                            onChange={(event) => updatePlanner(event,title,"sun")}
                            error={false}
                            helperText={''}
                            disabled={readonly}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        </div>
        </>
    );
}

export default PlannerShiftHoursRowNumber;